import React, {useEffect, useMemo, useState} from 'react';
import {useLocation} from 'react-router-dom';
import LoadScreen from '../loadScreen/LoadScreen';
import {Router} from './Router';

import type {Routes} from '@epic-mw/router';

interface Props {
  children: React.ReactNode;
  routes: {
    routes: Routes<string>;
  };
  /**
   * Name of origin of this app
   */
  originName: string;
}
/**
 * For the OriginRouter to be able to pick up on app page transitions correctly
 * there needs to be a splat route defined in the app, as otherwise the app will
 * 404 on unknown paths without updating the navigation object.
 */
export function OriginRouter({children, routes, originName}: Props) {
  const [isReloadingDocument, setIsReloadingDocument] = useState<boolean>(false);
  const location = useLocation();

  const router = useMemo(() => new Router<string>(routes.routes), [routes.routes]);
  useEffect(() => {
    if (!isReloadingDocument) {
      router.match({captureException: console.error}, location.pathname).then((origin: string) => {
        if (origin !== originName) {
          setIsReloadingDocument(true);
          window.location.replace(`${location.pathname}${location.search}`);
        }
      });
    }
  }, [isReloadingDocument, location.pathname, location.search, routes.routes, router, originName]);

  return <>{isReloadingDocument ? <LoadScreen show={true} /> : children}</>;
}
